import { render, staticRenderFns } from "./signatureAddressDetails.vue?vue&type=template&id=52b867e7&scoped=true&"
import script from "./signatureAddressDetails.vue?vue&type=script&lang=js&"
export * from "./signatureAddressDetails.vue?vue&type=script&lang=js&"
import style0 from "./signatureAddressDetails.vue?vue&type=style&index=0&id=52b867e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b867e7",
  null
  
)

export default component.exports